<div class="activity-details" c-toggle="showActivity">
    <div c-activity activity="activity"></div>
</div>